import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import Button from '@alltrails/denali/components/Button';
import HeroImage from '../HeroImage/HeroImage';
import styles from './MobileHeroImage.module.scss';

const messages = defineMessages({
  HERO_BUTTON: { defaultMessage: 'Show trail photo {index} of {photoCount, number}' }
});

type MobileHeroProps = {
  alt: string;
  onPhotoClick: () => void;
  photoCount: number;
  photoIndex: number;
  photoUrl: string;
  showPhotosCta: boolean;
  trailSlug: string;
};

const MobileHeroImage = ({ alt, onPhotoClick, photoCount, photoIndex, photoUrl, showPhotosCta = false, trailSlug }: MobileHeroProps) => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  const imageElement = useMemo(() => {
    return (
      <button
        aria-label={intl.formatMessage(messages.HERO_BUTTON, { index: photoIndex + 1, photoCount })}
        className={styles.carouselImage}
        disabled={!photoCount}
        onClick={onPhotoClick}
      >
        <div className={styles.carouselImageOverlay} />
        <HeroImage alt={alt} isLcp={photoIndex === 0} photoUrl={photoUrl} quality={75} />
      </button>
    );
  }, [alt, onPhotoClick, photoCount, photoIndex, photoUrl]);

  if (showPhotosCta) {
    const allPhotosText = intl.formatMessage({ defaultMessage: 'All photos' });
    return (
      <a aria-label={allPhotosText} href={wrapUrlSafe(`/trail/${trailSlug}/photos`, languageRegionCode)}>
        {imageElement}
        <div className={styles.showMore}>
          <Button text={allPhotosText} variant="inverse" />
        </div>
      </a>
    );
  }

  return imageElement;
};

export default MobileHeroImage;
